import { compose } from "recompose";
import { fetchApi } from "core/api/hoc";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { createLoadingSelector } from "core/helpers";
import * as hoc from "modules/user/auth/hoc";
import { isInsider } from "modules/user/auth/model";
import * as bookingApi from "modules/booking/api";
import * as bookingSelectors from "modules/booking/selectors";
import View from "./View";

export default compose(
  hoc.authorized(isInsider),
  fetchApi(bookingApi.getBookedCalls, {
    selector: bookingSelectors.getBookedCallsApi,
    key: "calls"
  }),
  fetchApi(bookingApi.getWaitingForFeedbackInsiders, {
    selector: bookingSelectors.getWaitingForFeedbackInsidersApi,
    key: "waitingFeedback"
  }),
  connect(
    createStructuredSelector({
      isLoading: createLoadingSelector(
        bookingSelectors.getBookedCallsApi,
        bookingSelectors.getWaitingForFeedbackInsidersApi
      )
    })
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/Dashboard/Provider.js